
// Filename - App.js

import React, { useEffect } from "react";
import {
    Route,
    Routes,
    BrowserRouter as Router,
    useNavigate,
    Outlet,
    Navigate,
} from "react-router-dom";

function PageNotFound() {
    const navigate = useNavigate();


    useEffect(() => {
        const user = localStorage.getItem("userData");
        const next = localStorage.getItem("next");

        if (!user) {
            localStorage.clear();
            navigate("/login", { replace: true });
        } else {
            switch (next) {
                case "copsdashboard":
                case "superuserdashboard":
                    navigate("/employer/dashboard", { replace: true });
                    break;
                case "employeedashboard":
                    navigate("/policies", { replace: true });
                    break;
                default:
                    // Optional: fallback navigation or do nothing
                    break;
            }
        }
    }, [navigate]);



    return (
        <>
            <div className="text-center  vh-100">
                <div className="not-found primary2 fw-bold">404</div>
                <h5>Page Not Found</h5>
            </div>
        </>
    );
}

export default PageNotFound;